type Meal = {
  planned_meal_type: string
}

const getPlannedMeals = (meals: Meal[]) => {
  return meals.filter(meal => !!meal.planned_meal_type)
}

export default getPlannedMeals
